document.addEventListener( 'DOMContentLoaded', function () {

  const topMenu = document.querySelector(
    'header .wp-block-navigation__container.is-responsive.wp-block-navigation'
  );

  const mobileMenu = document.querySelector( 'header #mega-menu-main-menu' );

  if ( !topMenu || !mobileMenu ) return;

  const appendedClass = 'appended-top-menu-item';

  function syncMenus() {
    const isMobile = window.innerWidth <= 1199;

    if ( isMobile ) {

      // Avoid duplication
      if ( mobileMenu.querySelector( `.${appendedClass}` ) ) return;

      // 1️⃣ Clone all LI items
      const liItems = topMenu.querySelectorAll( ':scope > li' );
      liItems.forEach( item => {
        const clone = item.cloneNode( true );
        clone.classList.add( appendedClass );
        mobileMenu.appendChild( clone );
      } );

      // 2️⃣ Clone the language switcher (the <div> block)
      const langSwitcher = topMenu.querySelector(
        ':scope > div.wpml-language-switcher-navigation-block'
      );

      if ( langSwitcher ) {
        const clone = langSwitcher.cloneNode( true );
        clone.classList.add( appendedClass );
        mobileMenu.appendChild( clone );
      }

    } else {
      // REMOVE appended items on desktop
      const appendedItems = mobileMenu.querySelectorAll( `.${appendedClass}` );
      appendedItems.forEach( item => item.remove() );
    }
  }

  syncMenus();

  window.addEventListener( 'resize', syncMenus );

} );
